import React from 'react';
import { Link } from 'react-router-dom';

const CardHeader = () => (
    <div className="card-header bg-transparent">
        <div className="row align-items-center">
            <div className="col">
                <h6 className="text-uppercase text-light ls-1 mb-1">Histórico</h6>
                <h2 className="mb-0">Últimas Operações</h2>
            </div>
            <div className="col text-right">
                <Link to="/zwallet/extrato" className="btn btn-sm btn-danger">Ver Extrato</Link>
            </div>
        </div>
    </div>
);

export default CardHeader;


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/LatestOperations/Header.js